import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CustomDataTable from './components/PickingPrioritization';
import Overlay from '../../Common/overlay';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const PickingPrioritization = ({ t }) => (
  <Container>
    <Row>
      <CustomDataTable />
    </Row>   
  </Container>
);

PickingPrioritization.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PickingPrioritization);
